/**
 * 简化 Query 参数(移除 Query 中值为空字符串的键)
 * @template {Record<string, string | string[]>} T
 * @param {T} query
 * @returns {Partial<T>}
 */
export function simplifyQuery(query) {
  return Object.keys(query).reduce((acc, key) => (query[key] !== '' ? { ...acc, [key]: query[key] } : acc), {})
}

export default {
  simplifyQuery
}
